import EmptyLayout from '@/layoutPage/EmptyLayout.vue'
import MainLayout from '@/layoutPage/MainLayout.vue'

const mainRouter = [
    {
        path : '/',
        name : 'index',
        component: () => import('../views/index.vue'),
        meta: {
            layout: MainLayout
        }
    },
    {
        path : '/login',
        name : 'LOGIN',
        component: () => import('@/views/login.vue')  ,
        meta:{
            layout : EmptyLayout,
            notReqLogin : true,
        }
    },
    {
        path : '/privacy',
        name : 'PRIVACY_POLICY',
        component: () => import('@/views/PrivacyPolicy.vue')  ,
        meta:{
            layout : EmptyLayout,
            notReqLogin : true,
        }
    }
    
]
export {mainRouter}